import { Injectable, Injector, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AppService } from './app.service';

@Injectable()
export class TrustedApiInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private injector = inject(Injector);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only add the header to API requests
    if (request.url.startsWith('/api/') || request.url.includes(environment.apiUrl)) {
      request = request.clone({
        setHeaders: {
          'X-Trusted-API': environment.trustedToken
        }
      });
    }

    // Pass the request to the next handler and catch any errors
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle 504 Gateway Timeout - redirect to desktop with maintenance message
        if (error.status === 504) {
          const maintenanceMessage = 'Le serveur est en maintenance. Veuillez réessayer dans quelques instants.';
          
          //
          // Mettre à jour l'app state avec le message de maintenance
          // et rediriger vers la page desktop (accessible sans auth)
          this.injector.get(AppService).updateState({ maintenanceMessage });
          this.router.navigate(['/']);
          
          const customError = new HttpErrorResponse({
            error: { message: maintenanceMessage },
            status: 504,
            statusText: 'Gateway Timeout',
            url: error.url,
            headers: error.headers
          });
          return throwError(() => customError);
        }

        // Re-throw the ORIGINAL error to preserve status, headers, etc.
        return throwError(() => error);
      })
    );
  }
}
